exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_contentOrganizerAdmin_3JTOPWWwgdfsiDBxs66f7R {\n  width: auto;\n  height: auto;\n}", ""]);

// Exports
exports.locals = {
	"IA_contentOrganizerAdmin": "IA_contentOrganizerAdmin_3JTOPWWwgdfsiDBxs66f7R"
};